import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import DropDown from "./DropDown";
import SocialWidget from "../Widget/SocialWidget";
import Newsletter from "../Widget/Newsletter";
import IconBoxStyle11 from "../IconBox/IconBoxStyle11";
import Spacing from "../Spacing";
import SearchBar from "../SearchBarEx";
import { APP_URL } from "../../Config/environment";
import { Menu, X, Info, LogIn } from "lucide-react";


const menuItems = [
  { name: "Doctors", icon: "/images/header/medical-team.png", link: "https://app.gkcklinica.com/public-profiles" },
  { name: "Book Tests", icon: "/images/header/blood-analysis.png", link: "/pricing-plan" },
  { name: "Membership", icon: "/images/header/hygiene.png", link: "/membership" },
  { name: "Insurance", icon: "/images/header/insurance.png", link: "https://app.gkcklinica.com/login?insurance=true" },
  // { name: "Surgery", icon: "/images/header/surgery-room.png", link: "/" },
  {
    name: "More",
    icon: "/images/header/three-dots.png",
    children: [
      { name: "Article", link: "/article" },
      { name: "Blogs", link: "/blog" },
      { name: "Services", link: "/services" },
      { name: "Terms", link: "/TermsCondition" },
      { name: "Policy", link: "/PrivacyPolicy" },
      { name: "FAQs", link: "/faq" },
    ],
  },
];
export default function Header({ logoSrc, variant }) {
  const [isSticky, setIsSticky] = useState(false);
  const [mobileToggle, setMobileToggle] = useState(false);
  const [sideNav, setSideNav] = useState(false);
  const [searchToggle, setSearchToggle] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 0);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <header
        className={`cs_site_header cs_style1 cs_sticky_header ${mobileToggle ? "cs_mobile_toggle_active" : ""
          } ${variant} ${isSticky ? "cs_active_sticky" : ""}`}
      >
        <div className="cs_main_header">
          <div className="container">

            {/* 🔹 TOP ROW */}
            <div className="cs_top_row">
              <Link to="/" className="cs_site_branding">
                <img src={logoSrc} alt="Logo" />
              </Link>

              {/* Desktop Links */}
              <div className="cs_top_links desktop-only">
                <Link to="/about">
                  <Info size={16} /> About Us
                </Link>
                <Link to={APP_URL}>
                  <LogIn size={16} /> Login
                </Link>
              </div>

              {/* Mobile Hamburger */}
              <button
                className="mobile-menu-btn"
                onClick={() => setMobileToggle(!mobileToggle)}
              >
                {mobileToggle ? <X size={24} /> : <Menu size={24} />}
              </button>
            </div>

            <div className={`mobile-menu ${mobileToggle ? "active" : ""}`}>

              {/* Mobile Links */}
              <div className="mobile-links">
                <Link to="/about" onClick={() => setMobileToggle(false)}><Info size={16} /> About Us </Link>
                <Link to={APP_URL} onClick={() => setMobileToggle(false)}><LogIn size={16} /> Login </Link>
              </div>

              {/* Icon Menu */}
              <ul className="cs_medimenu">
                {menuItems.map((item, i) => (
                  <li key={i}>

                    <div
                      className="mobile-item"
                      onClick={() => {
                        if (item.children) {
                          setOpenDropdown(openDropdown === i ? null : i);
                        } else {
                          setMobileToggle(false);
                        }
                      }}
                    >
                      <Link to={item.link || "#"} className="mobile-left">
                        {item.icon && <img src={item.icon} alt="" />}
                        <span>{item.name}</span>
                      </Link>

                      {item.children && (
                        <span className={`arrow ${openDropdown === i ? "open" : ""}`}>
                          ▾
                        </span>
                      )}
                    </div>

                    {/* Dropdown */}
                    {item.children && (
                      <div
                        className={`mobile-dropdown ${openDropdown === i ? "show" : ""
                          }`}
                      >
                        {item.children.map((sub, idx) => (
                          <Link
                            key={idx}
                            to={sub.link}
                            onClick={() => setMobileToggle(false)}
                          >
                            {sub.name}
                          </Link>
                        ))}
                      </div>
                    )}

                  </li>
                ))}
              </ul>

            </div>

            {/* 🔹 ICON MENU ROW */}
            <ul className="cs_medimenu  desktop-only">
              {menuItems.map((item, i) => (
                <li key={i} className={item.children ? "has-dropdown" : ""}>

                  <Link to={item.link || "#"}>
                    {item.icon && <img src={item.icon} alt={item.name} />}
                    {item.name}
                  </Link>
                  {/* Dropdown */}
                  {item.children && (
                    <ul className="dropdown">
                      {item.children.map((sub, idx) => (
                        <li key={idx}>
                          <Link to={sub.link}>{sub.name}</Link>
                        </li>
                      ))}
                    </ul>
                  )}

                </li>
              ))}

              {/* <li>
        <Link to="/">
          <img src="/images/header/medical-team.png" />
          Doctors
        </Link>
      </li>

      <li>
        <Link to="/">
          <img src="/images/header/blood-analysis.png" />
          Book Tests
        </Link>
      </li>

      <li>
        <Link to="/pricing">
          <img src="/images/header/nursing.png" />
          Packages
        </Link>
      </li>

      <li>
        <Link to="/">
          <img src="/images/header/insurance.png" />
          Insurance
        </Link>
      </li>

      <li>
        <Link to="/">
          <img src="/images/header/surgery-room.png" />
          Surgery
        </Link>
      </li>

      <li>
        <Link to="/">
          <img src="" />
          More
        </Link>
      </li> */}

            </ul>

            {/* 🔹 HERO BAR */}
            {!isSticky && (
              <div className="cs_hero_box">
                <span className="cs_hero_text">
                  Top Doctors just for you
                </span>

                <Link to={APP_URL} className="cs_hero_btn">
                  Book Consultation →
                </Link>
              </div>
            )}

          </div>
        </div>
      </header>

      {/* side nav and search markup unchanged */}
      <div className={`cs_sidenav ${sideNav ? "active" : ""}`}>
        <div
          className="cs_sidenav_overlay"
          onClick={() => setSideNav(!sideNav)}
        />
        <div className="cs_sidenav_in">
          <button
            className="cs_close"
            type="button"
            onClick={() => setSideNav(!sideNav)}
          >
            <img src="/images/icons/close.svg" alt="Close" />
          </button>
          <div className="cs_logo_box">
            <img src="/images/about/logo.png" alt="Logo" />
            <div className="cs_height_15" />
            <h3 className="cs_fs_24 cs_semibold mb-0">
              Your Partner in Health and Wellness
            </h3>
          </div>
          <Spacing md="35" lg="35" xl="35" />
          <hr />
          <Spacing md="35" lg="50" xl="35" />
          <IconBoxStyle11
            title="Phone"
            subTitle="+91-9766833510"
            iconSrc="/images/contact/icon_1.svg"
          />
          <Spacing md="30" lg="30" xl="30" />
          <IconBoxStyle11
            title="Email"
            subTitle="support@gkcklinica.com"
            iconSrc="/images/contact/icon_2.svg"
          />
          <Spacing md="30" lg="30" xl="30" />
          <IconBoxStyle11
            title="Location"
            subTitle="Head Office: GKC Tech24 Limited 4th Floor, Tirupati Enclave, Ram Nagar, Nagpur-10 (MS)"
            subTitle2=" Overseas Office:  GKC Tech24 L.L.C The Meydan Hotel, Grandstand 6th Floor, Nad Al Sheba, Dubai (U.A.E)"
            iconSrc="/images/contact/icon_3.svg"
          />
          <Spacing md="60" lg="60" xl="60" />
          <Spacing md="70" lg="50" xl="50" />
          <hr />
          <Spacing md="70" lg="50" xl="50" />
          <SocialWidget />
        </div>
      </div>

      <div className={`cs_header_search ${searchToggle ? "active" : ""}`}>
        <div className="cs_header_search_in">
          <div className="container">
            <div className="cs_header_search_box">
              <SearchBar />
              <button
                className="cs_close"
                type="button"
                onClick={() => setSearchToggle(!searchToggle)}
              >
                <img
                  src="/images/icons/close.svg"
                  alt="Close"
                />
              </button>
            </div>
          </div>
        </div>

        <div
          className="cs_sidenav_overlay"
          onClick={() => setSearchToggle(!searchToggle)}
        />
      </div>
    </>
  );
}
